import { render, staticRenderFns } from "./AtomSpecsInfo.vue?vue&type=template&id=3138c0fa&scoped=true&"
import script from "./AtomSpecsInfo.vue?vue&type=script&lang=js&"
export * from "./AtomSpecsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AtomSpecsInfo.vue?vue&type=style&index=0&id=3138c0fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3138c0fa",
  null
  
)

export default component.exports